module.exports = __webpack_public_path__ + "media/images/img_president-53a54bf56843b6ab14c9228222c4a76b.jpg";